import { CustomFontProperties } from 'common/utils/fontsUtils'
import { SearchInterface } from 'src/shared/types/entities/search-interface'

export const getSearchFontProperties = (entity: SearchInterface) => {
  const fontProperties = []
  if (entity.itemTitle.fontFamily) {
    fontProperties.push({
      fontFamily: entity.itemTitle.fontFamily,
      fontStyle: entity.itemTitle.fontStyle,
      fontWeight: entity.itemTitle.fontWeight,
    })
  }

  if (entity.itemTitle.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.itemTitle.mobileFontFamily,
      fontStyle: entity.itemTitle.mobileFontStyle,
      fontWeight: entity.itemTitle.mobileFontWeight,
    })
  }

  if (entity.itemText.fontFamily) {
    fontProperties.push({
      fontFamily: entity.itemText.fontFamily,
      fontStyle: entity.itemText.fontStyle,
      fontWeight: entity.itemText.fontWeight,
    })
  }

  if (entity.itemText.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.itemText.mobileFontFamily,
      fontStyle: entity.itemText.mobileFontStyle,
      fontWeight: entity.itemText.mobileFontWeight,
    })
  }

  if (entity.seeMore.fontFamily) {
    fontProperties.push({
      fontFamily: entity.seeMore.fontFamily,
      fontStyle: entity.seeMore.fontStyle,
      fontWeight: entity.seeMore.fontWeight,
    })
  }

  if (entity.seeMore.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.seeMore.mobileFontFamily,
      fontStyle: entity.seeMore.mobileFontStyle,
      fontWeight: entity.seeMore.mobileFontWeight,
    })
  }

  return fontProperties
}

export const getSearchCustomFontProperties = (entity: SearchInterface) => {
  const fontProperties: CustomFontProperties[] = []

  if (entity.itemTitle.fontFamily && entity.itemTitle.fontFileId) {
    fontProperties.push({
      fontFamily: entity.itemTitle.fontFamily,
      fontFileId: entity.itemTitle.fontFileId,
    })
  }
  if (entity.itemTitle.mobileFontFamily && entity.itemTitle.mobileFontFileId) {
    fontProperties.push({
      fontFamily: entity.itemTitle.mobileFontFamily,
      fontFileId: entity.itemTitle.mobileFontFileId,
    })
  }

  if (entity.itemText.fontFamily && entity.itemText.fontFileId) {
    fontProperties.push({
      fontFamily: entity.itemText.fontFamily,
      fontFileId: entity.itemText.fontFileId,
    })
  }
  if (entity.itemText.mobileFontFamily && entity.itemText.mobileFontFileId) {
    fontProperties.push({
      fontFamily: entity.itemText.mobileFontFamily,
      fontFileId: entity.itemText.mobileFontFileId,
    })
  }

  if (entity.seeMore.fontFamily && entity.seeMore.fontFileId) {
    fontProperties.push({
      fontFamily: entity.seeMore.fontFamily,
      fontFileId: entity.seeMore.fontFileId,
    })
  }
  if (entity.seeMore.mobileFontFamily && entity.seeMore.mobileFontFileId) {
    fontProperties.push({
      fontFamily: entity.seeMore.mobileFontFamily,
      fontFileId: entity.seeMore.mobileFontFileId,
    })
  }

  return fontProperties
}
